document.addEventListener('DOMContentLoaded',function(e){
  console.log('check tabs')
  /***************************Custom Tabs******************/
  function CustomTabs(){
    waitForElement('.tabs-component', function (e) {
      var mainTabsToggle = document.querySelectorAll('.tab a');
      var mainTabsContent = document.querySelectorAll('.tab-content');
      mainTabsToggle.forEach((tabToggle) => {
        tabToggle.addEventListener('click', function(e){
          e.preventDefault();
          mainTabsToggle.forEach((allTabToggle,index) => {
            allTabToggle.parentElement.classList.remove('is-active');
            mainTabsContent[index].classList.remove('is-active');
          });
          var tabsContentHref = this.getAttribute('href');

          var tabsContent = document.querySelector(tabsContentHref);
          tabsContent.classList.add('is-active');
          this.parentElement.classList.add('is-active');

          var tabFlickitySlider = document.querySelector(tabsContentHref).querySelector('.flickity-slider-enabled');
          if (!tabFlickitySlider) return;
          var tabFlickityOptions = tabFlickitySlider.dataset.flickity;
          var tabFlickityOptionsJSON = JSON.parse(tabFlickityOptions);
          var tabSlider = new Flickity(tabFlickitySlider,tabFlickityOptionsJSON);
          tabSlider.resize();
        });
      });
    });
  }
  CustomTabs();
  /***************************Custom Tabs******************/
});
